/**
 * Date period constants for date range selectors
 * Used across dashboard filters and file loader
 */
export const Periods = {
	LastWeek: 1,
	LastMonth: 2,
	Last3Months: 3,
	Last6Months: 4,
	Last12Months: 5,
	Custom: 6
}

/**
 * Period options with labels and icons for UI display
 */
export const PeriodOptions = [
	{
		value: Periods.LastWeek,
		text: 'Last week',
		icon: 'mdi-calendar-week'
	},
	{
		value: Periods.LastMonth,
		text: 'Last month',
		icon: 'mdi-calendar-month'
	},
	{
		value: Periods.Last3Months,
		text: 'Last 3 months',
		icon: 'mdi-calendar-multiple'
	},
	{
		value: Periods.Last6Months,
		text: 'Last 6 months',
		icon: 'mdi-calendar-range'
	},
	{
		value: Periods.Last12Months,
		text: 'Last 12 months',
		icon: 'mdi-calendar-outline'
	}
]

/**
 * Calculate start and end dates for a given period
 * @param {number} period - The period value from Periods enum
 * @returns {{ startDate: string, endDate: string }} ISO date strings (YYYY-MM-DD)
 */
export function calculateDatesForPeriod (period) {
	const today = new Date()
	const endDate = new Date(today)
	const startDate = new Date(today)

	switch (period) {
		case Periods.LastWeek:
			startDate.setDate(today.getDate() - 7)
			break
		case Periods.LastMonth:
			startDate.setDate(today.getDate() - 30)
			break
		case Periods.Last3Months:
			startDate.setMonth(today.getMonth() - 3)
			break
		case Periods.Last6Months:
			startDate.setMonth(today.getMonth() - 6)
			break
		case Periods.Last12Months:
			startDate.setFullYear(today.getFullYear() - 1)
			break
		default:
			return null
	}

	return {
		startDate: startDate.toISOString().split('T')[0],
		endDate: endDate.toISOString().split('T')[0]
	}
}
